var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsxs, jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import classNames from "classnames";
import Button from "./Button.mjs";
class ToggleSwitch extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "onClick", (e) => {
      if (e && this.props.stopPropagation) {
        e.stopPropagation();
      }
      this.props.onClick(!this.props.on);
    });
  }
  render() {
    const { label } = this.props;
    const toggleSwitch = classNames({
      "sa-toggle-switch": true,
      "on": this.props.on,
      "off": !this.props.on
    });
    const toggleSwitchCircle = classNames({
      "sa-toggle-switch-circle": true,
      "on": this.props.on,
      "off": !this.props.on
    });
    return /* @__PURE__ */ jsxs("div", { className: "sa-toggle-switch-wrapper", children: [
      /* @__PURE__ */ jsx(Button, { "aria-live": "assertive", "aria-label": `${label ? `${label}.` : ""} Switched ${this.props.on ? "on" : "off"}`, type: "button", elastic: true, onClick: this.onClick, disabled: this.props.disabled, children: /* @__PURE__ */ jsx("div", { className: toggleSwitch, children: /* @__PURE__ */ jsx("div", { className: toggleSwitchCircle }) }) }),
      label && /* @__PURE__ */ jsx("label", { className: "sa-toggle-switch-label", children: label })
    ] });
  }
}
export {
  ToggleSwitch as default
};
